module.exports = __webpack_public_path__ + "static/media/Slice15@2x.77535332.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice15@2x.png
// module id = 1443
// module chunks = 0